// ----
// split-screen and split-screen tab functionality
// ----

var SCM = SCM || {};

// the App.Global Module
(function (ns,
           $, 
           elementManager, 
           splitScreenHelper, 
           figuresAndTablesHelper, 
           contentsTocHelper,
           leftPaneHelper, 
           articleListNewAndPopular) {

    var ViewTypes = new function () { this.StandardView = 0; this.SplitView = 1; };

    function PositionManager(standardViewParagraphs, splitViewParagraphs) {

        this.getCurrentElement = function (viewType) {
            var paragraphs = viewType === ViewTypes.StandardView ? standardViewParagraphs : splitViewParagraphs;

            var tuple = elementManager.getElementAtTop(paragraphs);

            if (!tuple) {
                return;
            }

            var elem = tuple.elem;

            if (!elem) {
                return;
            }

            return elem;
        };
    }

    function WidgetCache() {
        var cache = {};

        this.getWidget = function (widgetClassName) {
            if (cache[widgetClassName]) {
                return cache[widgetClassName];
            }

            var widget = document.getElementsByClassName(widgetClassName)[0];
            if (widget) {
                cache[widgetClassName] = widget;
                return widget;
            } else {
                return undefined;
            }
        };
    }

    function WidgetStore() {
        var widgetCache = new WidgetCache();
        var dictionary = {};

        function resolveWidgets(widgetName, ctx) {
            var widget = dictionary[widgetName];
            var children = widget.dependencies;
            var resolvedWidgets = [];
            if (children) {
                for (var i = 0; i < children.length; i++) {
                    var childWidgetName = children[i];
                    var elem;
                    if (dictionary[childWidgetName]) {
                        elem = resolveWidgets(childWidgetName, ctx);
                        resolvedWidgets.push(elem);
                    } else {
                        elem = widgetCache.getWidget('widget-instance-' + childWidgetName) || widgetCache.getWidget('widget-' + childWidgetName);

                        if (elem) {
                            var clonedElem = elem.cloneNode(true);
                            splitScreenHelper.replaceIds(clonedElem);
                            resolvedWidgets.push(clonedElem);
                        } else {
                            resolvedWidgets.push(document.createDocumentFragment());
                        }
                    }
                }
            }

            var widgetRef = widget.render.apply(ctx, resolvedWidgets);
            ctx[widgetName] = widgetRef;

            return widgetRef;
        }

        this.create = function (widgetName) {
            var documentFragment = document.createDocumentFragment();
            documentFragment.appendChild(resolveWidgets(widgetName, {}));

            return documentFragment;
        };

        this.register = function (widget) {
            // Is it worth checking for cycles in the dependency graph?
            dictionary[widget.name] = widget;
        };
    }

    var store = new WidgetStore();
    ns.WidgetStore = store;

    // Set widget names based on whether the content is an article or a chapter
    var ContentFullTextWidgetName;
    var ContentTopInfoWidgetName;
    var ContentJumpLinksWidgetName;

    if (splitScreenHelper.isArticlePage()) {
        ContentFullTextWidgetName = 'ArticleFulltext';
        ContentTopInfoWidgetName = 'ArticleTopInfo';
        ContentJumpLinksWidgetName = 'ArticleJumpLinks';
    }
    else {
        ContentFullTextWidgetName = 'BookSectionsText';
        ContentTopInfoWidgetName = 'ChapterTopInfo';
        ContentJumpLinksWidgetName = 'BookTocSlim';
    }


    SCM.SplitScreen.init = function () {

        var revertToArticleContentView = (function () {
            var filters = elementManager.getElementsByClass(document, 'article-content-filter');
            var articleContentsToggle;
            for (var i = 0; i < filters.length; i++) {
                if (filters[i].dataset.contentFilter === 'article-content') {
                    articleContentsToggle = filters[i];
                }
            }
            
            return function () {
                if (articleContentsToggle) {
                    articleContentsToggle.click();
                }
            };
        })();

        (function () {
            var isSplitView = false;
            var $splitView;
            var positionManager;
            var contentFullTextClassName;
            var contentSplitViewClassName;

            if (splitScreenHelper.isArticlePage()) {
                contentFullTextClassName = '.widget-ArticleFulltext';
                contentSplitViewClassName = 'pg_articlesplitview';
            }
            else {
                contentFullTextClassName = '.widget-BookSectionsText';
                contentSplitViewClassName = 'pg_chaptersplitview';
            }

            function containsMathJax() {
                return $('.MathJax_Preview').length > 0 || $('.display-math').length > 0;
            }

            function transitionToSplitView() {
                SCM.SplitScreen.toggleSplitView();
            }

            var modalContent = elementManager.createElement('div', { 'class': 'math-jax-modal' }, [
                elementManager.createElement('p', { 'class': 'bold' }, ['Mathematical content on this page is still rendering']),
                elementManager.createElement('div', { 'class': 'spinner' }),
                elementManager.createElement('p', {}, ['Once the process is complete you will be taken to Split View']),
                elementManager.createElement('button', {
                    'onclick': function () {
                        $('#math-jax-modal').foundation('reveal', 'close');
                    },
                    'class': 'btn'
                }, ['Cancel'])
            ]);

            var m = elementManager.createElement('div', { 'data-reveal': 'math-jax-load', 'id': 'math-jax-modal', 'class': 'reveal-modal' });
            m.style.display = 'none';

            document.body.appendChild(m);

            SCM.SplitScreen.toggleSplitView = function (override) {

                if (override === false) {
                    if (!$splitView) return;
                    isSplitView = true;
                } else if (override === true) {
                    isSplitView = false;
                }
                $('.close-reveal-modal').click();

                if (containsMathJax() && !SCM.SplitScreen.IsMathJaxLoaded) {
                    var modal = $('#math-jax-modal');
                    $(document).on('closed.fndtn.reveal', '[data-reveal]', function () {
                        window.removeEventListener('MathJax.complete', transitionToSplitView);
                    });
                    modal.empty().prepend(modalContent);
                    modal.foundation('reveal', 'open');
                    window.addEventListener('MathJax.complete', transitionToSplitView);
                    return;
                } else {
                    $('#math-jax-modal').foundation('reveal', 'close');
                }

                if (!SCM.SiteJS.isFinishedAdjustRelatedTagsDisplay()) {
                    window.addEventListener('adjustRelatedTagsDisplay.complete', transitionToSplitView);
                    return;
                }

                // Check if split view has already been created
                if (!$splitView) {
                    positionManager = createSplitViewHtml(contentFullTextClassName);

                    if (window.addthis) {
                        window.addthis.toolbox('.addthis_toolbox');
                    }
                    initializeSplitViewJs();

                    $splitView = document.body.lastChild;
                }
               
                var masterContainer = elementManager.getFirstElementByClassName(document, 'master-container');
                var siteFooter = elementManager.getFirstElementByClassName(document, 'widget-SitePageFooter');
                var globalFooter = elementManager.getFirstElementByClassName(document, 'oup-footer');

                var viewType = isSplitView ? ViewTypes.SplitView : ViewTypes.StandardView;
                var elem = positionManager.getCurrentElement(viewType);
                
                if (isSplitView) {
                    document.body.className = document.body.className.replace(' ' + contentSplitViewClassName, '');
                    masterContainer.style.display = '';
                    siteFooter.style.display = '';
                    globalFooter.style.display = '';
                    $splitView.style.display = 'none';

                    splitScreenHelper.positionStandardViewBasedOnSplitScreen(elem);

                } else {
                    displaySplitView(masterContainer, siteFooter, globalFooter, contentSplitViewClassName, $splitView).then(() => {
                        $('.js-content-panel').focus();
                        splitScreenHelper.positionSplitScreenBasedOnStandardView(elem);
                    });

                    SCM.JumpLinks.registerFootNotesLink();                   
                    splitScreenHelper.registerMetricsClicks();
                    splitScreenHelper.adjustToolbarMargins();
                }
                $(document).trigger('splitScreenEvent', isSplitView);
                isSplitView = !isSplitView;
            };

            SCM.SplitScreen.isSplitView = function () {
                return isSplitView;
            };
        })();

        var splitViewButton = elementManager.getFirstElementByClassName(document, 'js-split-view');

        if (splitViewButton) {

            var $splitViewButton = $(splitViewButton);
            if (!$splitViewButton.is(':visible')) {
                $splitViewButton.parent().remove();
            }

            var checkScreenSize = function(m) {
                if (m.matches) {
                    SCM.SplitScreen.toggleSplitView(false);
                } else {
                    if (elementManager.getFirstElementByClassName(document, 'item-views')) {
                        revertToArticleContentView();
                    }
                }
            };
            
            var mobileBreakpoint = window.matchMedia('(max-width: 930px)');
            mobileBreakpoint.addListener(checkScreenSize);
            checkScreenSize(mobileBreakpoint);

            $(document).on('click', '.js-split-view', SCM.SplitScreen.toggleSplitView);
        }

        SCM.Retry.policy()
            .handleResult(function (result) { return !result; }) // Retry when our execute function returns false
            .waitAndRetry(5, 500) // Retry 5 times, waiting 500ms between each try
            .execute(function () {
                return !!(MathJax && MathJax.startup && MathJax.startup.promise);
            })
            .then(function () {
                MathJax.startup.promise.then(() => {
                    SCM.SplitScreen.IsMathJaxLoaded = true;
                    window.dispatchEvent(new CustomEvent('MathJax.complete'));
                });
            })
            .catch(function () {
                console.error('Timed out waiting for MathJax library to be ready.');
            });
    };

    function createSplitViewHtml(contentFullTextClassName) {
        var elementsToAddId = 'p,section.abstract,blockquote,div.block-child-p,div.lay-summary';
        var elementsToIncludeInSwitch = 'h2,h3,h4,.js-footnotes-target,.footnote,.js-content-section,.js-paywall';
        var nestedElements = '.standard-table,.fig-section,.js-splitscreen-figure-title,.audio-section,.js-splitscreen-audio-title,.video-section,.js-splitscreen-video-title,.js-splitview-ref-list';
        // Add ids to paragraphs before loading split view
        var contentWidgetItemClassNames = contentFullTextClassName + ' .widget-items';
        var $contentWidgetItems = $(contentWidgetItemClassNames);
        $contentWidgetItems.children(elementsToAddId).each(function (idx, elem) {
            elem.id = elem.id || 'scroll-to-' + idx;
        });

        var $contentBody = $('.js-content-body');
        var standardViewParagraphs = $contentWidgetItems.children(elementsToAddId + ',' + elementsToIncludeInSwitch)
            .add($contentWidgetItems.find(nestedElements))
            .add($contentBody.find($('.js-end-notes-target')))
            .add($contentBody.find($('.widget-ChapterAbstract')));

        document.body.appendChild(store.create('SplitView'));

        var $leftPaneContent = $('.location-left-panel');
        var paragraphClassNames = '#sv_main ' + contentWidgetItemClassNames;
        var splitViewParagraphs = $(paragraphClassNames).children(elementsToAddId + ',' + elementsToIncludeInSwitch)
            .add($leftPaneContent.find($('.widget-ChapterAbstract')));       

        return new PositionManager(standardViewParagraphs, splitViewParagraphs);
    }

    function initializeSplitViewJs() {
        articleListNewAndPopular.registerArticleListNewAndPopularCombinedMode();
        SCM.Utilities.Brightcove.init();
        SCM.SiteJS.articleUserComments(true);
        SCM.RefLinks.showParagraphCitations();
        SCM.Toolbar.collapseShareDropdownOnTab();
        splitScreenHelper.registerXrefClicks();
        SCM.Toolbar.registerAnnotateLink();
    }

    function displaySplitView(masterContainer, siteFooter, globalFooter, contentSplitViewClassName, $splitView) {
        return new Promise((resolve) => {
            masterContainer.style.display = 'none';
            siteFooter.style.display = 'none';
            globalFooter.style.display = 'none';
            if (document.body.className.indexOf(contentSplitViewClassName) < 0) {
                document.body.className += ' ' + contentSplitViewClassName;
            }
            $splitView.style.display = '';
            resolve();
        });
    }


    /* 
     * Register widgets 
     */

    SCM.SplitScreen.WidgetStore.register({
        name: 'ContentsTab',
        dependencies: [ContentJumpLinksWidgetName, ContentFullTextWidgetName],
        render: function (ContentJumpLinks, ContentFullText) {
            var widgets = this;

            elementManager.removeElementsByClass(ContentJumpLinks, 'contents-title');

            var $contentJumpLinks = $(ContentJumpLinks);
            $contentJumpLinks.on('click', '.js-jumplink', function (e) {
                e.preventDefault();
                contentsTocHelper.handleJumpLinks(e.currentTarget, widgets);
            });

            contentsTocHelper.setDataSectionTypeForJumpLinks(ContentFullText, ContentJumpLinks);

            return elementManager.createElement('div', { 'class': 'dynamic-widget-inner-wrap split-view-contents at-split-view-contents', 'style': 'display: block;' }, [
                ContentJumpLinks
            ]);
        }
    });

    SCM.SplitScreen.WidgetStore.register({
        name: 'FiguresAndTablesTab',
        dependencies: [ContentFullTextWidgetName],
        render: function (ContentFullText) {
            var figures = figuresAndTablesHelper.getFigures(ContentFullText);

            var tables = figuresAndTablesHelper.getTables(ContentFullText);

            var videos = elementManager.getElementsByClassList(ContentFullText, ['js-splitscreen-video-title', 'video-section']);

            var audio = elementManager.getElementsByClassList(ContentFullText, ['js-splitscreen-audio-title', 'audio-section']);

            var children = figures.concat(tables).sort(elementManager.elementComparator);
            children = children.concat(videos).sort(elementManager.elementComparator);
            children = children.concat(audio).sort(elementManager.elementComparator);

            // Add a 'download all' button
            if (figures.length > 0) {
                var downloadAllLinks = document.getElementsByClassName('js-download-all-images-link');
                if (downloadAllLinks.length) {
                    var downloadAllLink = downloadAllLinks[0].cloneNode(true);
                    downloadAllLink.className = 'js-download-all-images-link-sv';
                    downloadAllLink.textContent = 'Download all slides';
                    elementManager.elementAddClass(downloadAllLink, 'btn');
                }
                children = [elementManager.createElement('div', { 'class': 'download-all-ppt' }, [downloadAllLink])].concat(children);
            }

            if (children.length > 0) {
                return elementManager.createElement('div', { 'class': 'dynamic-widget-inner-wrap at-split-view-FiguresTables js-sv-figuresTables' }, children);
            }
            else {
                return elementManager.createElement('div', { 'class': 'dynamic-widget-inner-wrap' });
            }
        }
    });

    SCM.SplitScreen.WidgetStore.register({
        name: 'ReferencesTab',
        dependencies: [ContentFullTextWidgetName],
        render: function (ContentFullText) {
            var references = elementManager.getElementsByClassList(ContentFullText, [
                'js-splitscreen-reference-target',
                'js-splitscreen-backreferences-title',
                'js-splitscreen-references-title',
                'section-type--references',
                'js-splitview-paragraph-ref',
                'js-splitview-ref-list']);
            // Exclude references inside footnotes
            references = references.filter(function (el) {
                var footnote = el.closest('.fn');
                return footnote === null;
            });
            // Order references
            references.sort(elementManager.elementComparator);

            return elementManager.createElement('div', { 'class': 'dynamic-widget-inner-wrap split-view-references at-split-view-references js-sv-references' }, references);
        }
    });

    SCM.SplitScreen.WidgetStore.register({
        name: 'NotesTab',
        dependencies: [ContentFullTextWidgetName, ContentTopInfoWidgetName],
        render: function (ContentFullText) {
            var notes = elementManager.getElementsByClassList(ContentFullText, [
                'js-splitscreen-backnotes-title',
                'js-splitscreen-backfootnotegroup-title',
                'js-splitscreen-footnotegroup-title',
                'footnote', 
                'js-footnotes-target']);
           
            // need to do chapter end notes differently since it's outside ContentFullText
            var children = notes;
            var endNotes = elementManager.getFirstElementByClassName(document, 'js-end-notes-target');
            if (endNotes) {
                 children = children.concat(endNotes.cloneNode(true));
            }
            // remove duplicates of footnotes
            // have to pull in footnote class due to articles, but they are also in the 
            // book sections too so you end up with duplicates.
            // also leave out table footnotes
            children = children.filter(function (el) {
                var elementOKToUse = true;
                if (el.classList.contains('footnote') &&
                    (el.parentElement.closest('.js-footnotes-target') !== null || el.parentElement.closest('.js-end-notes-target') !== null) ||
                     el.closest('.table-wrap-foot') != null) {
                    elementOKToUse = false;
                }
                return elementOKToUse;
            });
            if (children.length > 0) {
                return elementManager.createElement('div', { 'class': 'dynamic-widget-inner-wrap at-split-view-notes split-view-notes js-sv-notes' }, children);
            }
            else {
                return elementManager.createElement('div', { 'class': 'dynamic-widget-inner-wrap' });
            }
        }
    });

    SCM.SplitScreen.WidgetStore.register({
        name: 'CommentsTab',
        dependencies: ['UserCommentBody'],
        render: function (UserCommentBody) {
            return elementManager.createElement('div', { 'class': 'dynamic-widget-inner-wrap at-split-view-comments' }, [
                UserCommentBody
            ]);
        }
    });

    SCM.SplitScreen.WidgetStore.register({
        name: 'RelatedTab',
        dependencies: [],
        render: function () {
            return elementManager.createElement('div', { 'class': 'dynamic-widget-inner-wrap split-view-related at-Related-tab-content' }, [
                splitScreenHelper.getRightRailWithoutSpecifiedWidgets(['widget-AdBlock'])
            ]);
        }
    }); 

    SCM.SplitScreen.WidgetStore.register({
        name: 'Tabs',
        dependencies: ['ContentsTab', 'FiguresAndTablesTab', 'ReferencesTab', 'NotesTab', 'CommentsTab', 'RelatedTab'],
        render: function (ContentsTab, FiguresAndTablesTab, ReferencesTab, NotesTab, CommentsTab, RelatedTab) {         

            function updateTabFocus(tab, panel) {
                for (var i = 0; i < tabs.length; i++) {
                    elementManager.elementRemoveClass(tabs[i], 'active');
                }

                elementManager.elementAddClass(tab, 'active');
                for (var j = 0; j < panels.length; j++) {
                    panels[j].style.display = 'none';
                }

                panel.style.display = 'block';
                
                splitScreenHelper.updatePageNumberCss();
            }

            function tabClick(e) {
                var t = e.target.parentNode;
                updateTabFocus(t, panels[t.dataset.tab]);
            }

            var idx = 0;
            function tabElement(name, cssName, isActive) {
                return elementManager.createElement('a', { 'class': 'tab-nav-trigger tab-nav-' + cssName + 'Css' + (isActive ? ' active' : ''), 'data-tab': idx++ }, [
                    elementManager.createElement('i', { 'class': 'icon-' + cssName + 'Css' }, [
                        elementManager.createElement('span', { 'class': 'sr-t' })
                    ]),
                    elementManager.createElement('div', { 'class': 'tab-nav-tab-name js-' + cssName + '-tab-trigger at-' + cssName + '-tab-trigger', 'onclick': tabClick }, [
                        name
                    ])
                ]);
            }


            var tabs = [
                tabElement('Contents', 'Content', true),
                tabElement('Figures & Tables', 'FiguresTables'),
                tabElement('References', 'References'),
                tabElement('Notes', 'Notes'),
                tabElement('Comments', 'Comments'),
                tabElement('Related', 'Related')];

            var panels = [
                ContentsTab,
                FiguresAndTablesTab,
                ReferencesTab,
                NotesTab,
                CommentsTab,
                RelatedTab
            ];

            for (var i = 0; i < panels.length; i++) {
                if (panels[i].textContent.trim() === '') {
                    tabs[i].style.display = 'none';
                    panels[i].switchTo = function () { };
                } else {
                    panels[i].switchTo = function () {
                        updateTabFocus(this.tab, this.panel);
                    }.bind({ panel: panels[i], tab: tabs[i] });
                }
            }

            return elementManager.createElement('div', { 'class': 'resources-panel' }, [
                elementManager.createElement('div', { 'class': 'location-right-pane' }, [
                    elementManager.createElement('div', { 'class': 'dynamic-widget-module' }, [
                        elementManager.createElement('div', { 'class': 'tab-nav', 'style': 'visibility: visible;' }, tabs),
                        elementManager.createElement('div', { 'class': 'resource-tabs at-splitView-resourceTabs' }, panels)
                    ])
                ])
            ]);
        }
    });

    SCM.SplitScreen.WidgetStore.register({
        name: 'Content',
        dependencies: [ContentFullTextWidgetName, ContentTopInfoWidgetName, 'ArticleLinks', 'ArticleDataSupplements', 'ChapterAbstract', 'SolrResourceMetadata', 'ChapterVersionInformation', 'DrugDisclaimer', 'CopyrightStatement'],
        render: function (ContentFullText, ContentTopInfo, ArticleLinks, ArticleDataSupplements, ChapterAbstract, SolrResourceMetadata, ChapterVersionInformation, DrugDisclaimer, CopyrightStatement) {
            var widgets = this;

            //remove GraphicalAbstract section
            var graphicalAbstract = elementManager.getFirstElementByClassName(ContentFullText, 'graphicalAbstract');
            if (graphicalAbstract != null)
                elementManager.removeElements([graphicalAbstract]);

            elementManager.removeElementsByClassList(ContentFullText, [
                'fig-section',
                'js-sec-fig-section',
                'js-p-fig-section',
                'figure-title',
                'js-splitscreen-figure-title',
                'js-splitscreen-tablegroup-title',
                'standard-table',
                'js-splitscreen-backnotes-title',
                'js-splitscreen-backfootnotegroup-title',
                'js-splitscreen-footnotegroup-title',
                'footnote',
                'js-footnotes-target',
                'js-splitscreen-video-title',
                'video-section',
                'js-splitscreen-audio-title',
                'audio-section',
                'js-splitscreen-reference-target',
                'js-splitscreen-backreferences-title',
                'js-splitscreen-references-title',
                'section-type--references',
                'js-splitview-ref-list',
                'js-splitview-paragraph-ref']);

            leftPaneHelper.registerLeftPaneClickAndResizeEvents(widgets, ContentFullText, ContentTopInfo, SolrResourceMetadata, ChapterVersionInformation);

            var body = [
                ContentTopInfo,
                ArticleLinks,
                ChapterAbstract,
                SolrResourceMetadata,
                ChapterVersionInformation,
                DrugDisclaimer,
                ContentFullText,
                CopyrightStatement
            ];

            if (ArticleDataSupplements) {
                body.push(ArticleDataSupplements);
            }

            return elementManager.createElement('div', {
                'class': 'content-panel js-content-panel',
                'onscroll': debounce(() => contentsTocHelper.highlightSectionTitle(widgets), 16),
                'id': 'split-view-scroll-pane',
                'tabIndex': '0'
            }, [
                elementManager.createElement('div', { 'class': 'location-left-panel' }, [
                    elementManager.createElement('div', { 'class': 'content-inner-wrap' }, [
                        elementManager.createElement('div', { 'class': 'article-body' }, [
                            elementManager.createElement('div', { 'class': 'content active' }, body)
                        ])
                    ])
                ])
            ]);
        }
    });

    SCM.SplitScreen.WidgetStore.register({
            name: 'SwitchView',
            render: function () {
                return elementManager.createElement('li', { 'class': 'toolbar-item item-link' }, [
                    elementManager.createElement('a', { 'class': 'standard-view at-standard-view', href: 'javascript:;', 'onclick': SCM.SplitScreen.toggleSplitView }, [
                        elementManager.createElement('i', { 'class': 'icon-menu_standard' }),
                        'Standard view'
                    ])
                ]);
            }
    });

    SCM.SplitScreen.WidgetStore.register({
        name: 'PdfLink',
        render: function () {
            var pdfLink = elementManager.getFirstElementByClassName(document, 'js-item-pdf');
            if (pdfLink) {
                return pdfLink.cloneNode(true);
            }
        }
    });

    // Annotate button is for specialized Hypothes.is support 
    // see NARN-18099
    SCM.SplitScreen.WidgetStore.register({
        name: 'Annotate',
        render: function () {
            var annotateLink = elementManager.getFirstElementByClassName(document, 'js-item-annotate');
            if (annotateLink) {
                return annotateLink.cloneNode(true);
            }
        }
    });

    SCM.SplitScreen.WidgetStore.register({
        name: 'ShareThis',
        render: function () {
            var shareWidget = elementManager.getFirstElementByClassName(document, 'item-share');
            if (shareWidget) {
                shareWidget = shareWidget.cloneNode(true);
                var dropTrigger = elementManager.getFirstElementByClassName(shareWidget, 'drop-trigger');
                if (dropTrigger) {
                    dropTrigger.addEventListener('click', function (e) {
                        e.preventDefault();
                        var $this = $(this);
                        $this.siblings('ul').slideToggle();
                    });
                }
                return shareWidget;
            }
        }
    });

    SCM.SplitScreen.WidgetStore.register({
        name: 'ToolbarCitation',
        render: function () {
            var toolbarCiteItem = elementManager.getFirstElementByClassName(document, 'js-item-cite');
            var citeButton = elementManager.getFirstElementByClassName(toolbarCiteItem, 'js-cite-button');

            if (toolbarCiteItem && citeButton) {
                var splitViewToolbarCiteItem = toolbarCiteItem.cloneNode(true);
                var splitViewCiteButton = elementManager.getFirstElementByClassName(splitViewToolbarCiteItem, 'js-cite-button');
                splitViewCiteButton.setAttribute('data-reveal-id', 'sv-' + citeButton.getAttribute('data-reveal-id'));
                // Articles nest the citation modal within the toolbar citation element, and chapters have the modal in a
                // separate element. We're handling the modal in a separate element. So, to avoid duplicates in articles, 
                // remove the nested citation modal from splitview.
                elementManager.removeElementsByClass(splitViewToolbarCiteItem, 'js-citation-modal');

                return splitViewToolbarCiteItem;
            }
        }
    });

    SCM.SplitScreen.WidgetStore.register({
        name: 'CitationModal',
        render: function () {
            var citationModal = elementManager.getFirstElementByClassName(document, 'js-citation-modal');
            if (citationModal) {
                var splitViewCitationModal = citationModal.cloneNode(true);
                splitViewCitationModal.id = 'sv-' + citationModal.id;
                return splitViewCitationModal;
            }
        }
    });

    SCM.SplitScreen.WidgetStore.register({
        name: 'Toolbar',
        dependencies: ['ToolbarCitation', 'CitationModal', 'PdfLink', 'ShareThis', 'SwitchView', 'Annotate'],
        render: function (ToolbarCitation, CitationModal, PdfLink, ShareThis, SwitchView, Annotate) {
            return elementManager.createElement('div', { 'class': 'toolbar-wrap' }, [
                elementManager.createElement('div', { 'class': 'toolbar-inner-wrap' }, [
                    elementManager.createElement('ul', { 'id': 'Toolbar', 'role': 'navigation' }, [
                        PdfLink,
                        SwitchView,
                        Annotate,
                        ToolbarCitation,
                        CitationModal,
                        ShareThis
                    ])
                ])
            ]);
        }
    });

    SCM.SplitScreen.WidgetStore.register({
        name: 'SplitView',
        dependencies: ['Content', 'Tabs', 'Toolbar'],
        render: function (Content, Tabs, Toolbar) {
            // Rebuild Brightcove video/audio elements so Brightcove can re-render them.
            // Otherwise, they end up non-functional.
            figuresAndTablesHelper.runVideoJsFixups(Content);
            figuresAndTablesHelper.runVideoJsFixups(Tabs);

            return elementManager.createElement('div', { 'class': 'master-container' }, [
                elementManager.createElement('main', { id: 'sv_main', 'class': 'js-sv-main' }, [
                    elementManager.createElement('section', { 'class': 'master-main row' }, [
                        elementManager.createElement('div', { 'class': 'center-inner-row no-overflow' }, [
                            elementManager.createElement('div', { 'class': 'widget widget-SplitView widget-instance-SplitView_Article' }, [
                                elementManager.createElement('div', { 'class': 'pseudo-splitview-header js-sv-header' }, [elementManager.createElement('div', { 'class': 'pseudo-inner-wrap' }, [Toolbar])]),
                                elementManager.createElement('div', { 'class': 'index-inner-wrap' }, [
                                    Tabs,
                                    Content
                                ])
                            ])
                        ])
                    ])
                ])
            ]);
        }
    });

    
})(SCM.SplitScreen = SCM.SplitScreen || {},
                                        jQuery,
                                        SCM.ElementManager,
                                        SCM.SplitScreenHelper,
                                        SCM.SplitScreenFiguresAndTables,
                                        SCM.SplitScreenContentsToc,
                                        SCM.SplitScreenLeftPane,
                                        SCM.ArticleListNewAndPopular);